const getHomeStoreDomain = () => {
  switch (window.location.hostname) {
    case 'www.zola.com':
      return 'https://homestore.zola.com';
    case 'qa.zola.com':
      return 'https://qa-homestore.zola.com';
    case 'localhost':
      return 'http://localhost:9000';
    default:
      return 'https://homestore.zola.com';
  }
};

export default {
  getHomeStoreDomain,
};
